module.exports = __webpack_public_path__ + "media/3_30.2f3c3607.wav";